import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as r } from "../SvgIcon.js";
const v = (h) => /* @__PURE__ */ o(r, { ...h, children: /* @__PURE__ */ o("path", { d: "M10.0055 0C4.47267 0 0 4.47267 0 10.0055 0 15.5273 4.47267 20 9.99448 20c5.52182 0 9.99452-4.4727 9.99452-9.9945C20 4.47267 15.5273 0 10.0055 0Zm4.9917 10.8338h-4.1634v4.1745H9.16621v-4.1745H5.00276V9.16621h4.16345V5.00276h1.66759v4.16345h4.1634v1.66759Z" }) });
export {
  v as Add
};
//# sourceMappingURL=Add.js.map
